import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';

@Component({
  selector: 'app-student-portal-master',
  imports: [NgFor, RouterLink, NgClass, SelectInputComponent, NgIf, HeaderComponent, SearchInputComponent],
  templateUrl: './student-portal-master.component.html',
  styleUrl: './student-portal-master.component.css'
})
export class StudentPortalMasterComponent {
 open_state: any = {};

  toggle_card(i: number) {
    this.open_state[i] = !this.open_state[i];
  }

  master_groups = [
    {
      title: 'Student Portal',
      icon: 'bx-user',
      links: [
       { label: 'Exam Results', link: '/student-portal/list' },
       { label: 'Re-evaluations', link: '/re-evaluations/list' },
        { label: 'Payment History', link: '/transaction-history/list' },
      ]
    },
  ];
}
